module.exports = __webpack_public_path__ + "img/fyzdj.5e731c9b.png";